export class InvoiceRequestModel {
    orderEntryCode: string;
	quantity: number;

    constructor() {
        this.orderEntryCode = "";
        this.quantity = 0;     
    }
}